/**
 * Repro script
 */
class ME_RepoForm {
    constructor() {
        this.initState();
    }

    initState() {
        this.repoForm = $('form.repo-form');
        this.submitRepoFormBtn = this.repoForm.find('.repo-form-submit');

        if (!this.repoForm.length) {
            return
        }

        this.initEvents();
    }

    initEvents() {
        let formHelper = new ME_FormHelper(this.repoForm);
        this.submitRepoFormBtn.addClass('is-loading');

        this.submitRepoFormBtn.on('click', e => {
            e.preventDefault();
            let result = formHelper.formValidate();

            if (result) {
                this.runRecaptchaCheck();
            }
        });
    }

    runRecaptchaCheck () {
        let inputField = this.repoForm.find('[name="g-recaptcha-response"]');
        let recaptchaKey = this.repoForm.attr('data-recaptcha-site-key');
        let recaptchaValidationInfo = this.repoForm.find('.recaptcha-validation')

        grecaptcha.ready(function () {
            grecaptcha.execute(recaptchaKey).then(function(token) {
                inputField.val(token)
                inputField.addClass('success');
                $('form.repo-form').submit()
            }).catch(function () {
                inputField.addClass('error');
                recaptchaValidationInfo.removeClass('is-hidden');
            });
        });
    }
}
